import { Component, EventEmitter, Input, Output } from "@angular/core";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

@Component({
  selector: "verbal-tool",
  templateUrl: "verbal-tool.html",
})
export class VerbalToolComponent {
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;
  value: number = null;
  description: string = "None";
  label: string = "verbalToolDesc";

  constructor(public stateData: StateManagementService) {
    if (this.existingData) {
      this.value = this.existingData["values"]["verbal"];
    }
  }

  onFocus() {
    setTimeout(() => {
      if (this.value === null) {
        this.value = 0;
        this.onValueUpdate.emit({
          severity: this.value,
          values: {
            verbal: this.value,
          },
        });
      }
    }, 250);
  }

  valueChanged(value: number) {
    this.value = value;
    this.stateData.setMyData(this.value);
    if (value === 0) {
      this.description = "No Pain";
    } else if (value === 2) {
      this.description = "Mild Pain";
    } else if (value === 4) {
      this.description = "Moderate Pain";
    } else if (value === 6) {
      this.description = "Severe Pain";
    } else if (value === 8) {
      this.description = "Very Severe Pain";
    } else if (value === 10) {
      this.description = "Worst Possible Pain";
    } else {
      this.description = "";
    }
    this.onValueUpdate.emit({
      severity: value,
      values: {
        verbal: value,
      },
    });
  }

  @Input() set existingData(data: object) {
    if (data && data["tool"] === "verbal" && data["values"]) {
      this.value = data["values"]["verbal"];
      if (this.value === 0) {
        this.description = "No Pain";
      } else if (this.value === 2) {
        this.description = "Mild Pain";
      } else if (this.value === 4) {
        this.description = "Moderate Pain";
      } else if (this.value === 6) {
        this.description = "Severe Pain";
      } else if (this.value === 8) {
        this.description = "Very Severe Pain";
      } else if (this.value === 10) {
        this.description = "Worst Possible Pain";
      } else {
        this.description = "";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/verbal-tool/verbal-tool.ts